import {
  CANCEL_DIGITAL_ORDER_ERROR,
  CANCEL_DIGITAL_ORDER_REQUEST,
  CANCEL_DIGITAL_ORDER_SUCCESS,
} from "./ActionType";

const initialState = {
  isRequest: false,
  isSuccess: false,
  isError: false,
  cancelDigitalOrder: {}
};

const reindexReducer = (state = initialState, action) => {
  switch (action.type) {
    case CANCEL_DIGITAL_ORDER_REQUEST:
      return {
        ...state,
        isRequest: true,
        isSuccess: false,
        isError: false,
        cancelDigitalOrder: action.payload,
      };
    case CANCEL_DIGITAL_ORDER_SUCCESS:
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        cancelDigitalOrder: action.payload,
      };
    case CANCEL_DIGITAL_ORDER_ERROR:
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        cancelDigitalOrder: action.payload,
      };
    default:
      return state;
  }
};

export default reindexReducer;